/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors } from '@blend/consumer-components';
import { focusById } from '../../../common/domUtils/focusById';
import { LinkButtonWrapper } from '@components/LinkButton/LinkButtonWrapper';
import { LinkButtonContentWrapper } from '@components/LinkButton/LinkButtonContentWrapper';
import { LinkButtonTextWrapper } from '@components/LinkButton/LinkButtonTextWrapper';

const styles = StyleSheet.create({
  wrapper: {
    position: 'absolute',
    top: 0,
  },
  showOnFocus: {
    position: 'absolute',
    top: 0,
    left: 0,
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: colors.white,
    display: 'flex',
    padding: '0 10px',
    height: 0,
    width: 0,
    border: 'none',
    overflow: 'hidden',
    fontWeight: 500,
    ':focus': {
      border: `2px solid ${colors.black}`,
      width: 180,
      height: 40,
    },
  },
});

const skipToMainContent = () => {
  focusById('js-main-content');
};

export namespace SkipToMainContent {
  export interface Props {}
}

export const SkipToMainContent: React.FC<SkipToMainContent.Props> = () => {
  // Because the Wrapper component does not allow overriding the className component,
  // we have to wrap the Wrapper (or set inline styles on the Wrapper). :(
  return (
    <div className={css(styles.wrapper)}>
      <LinkButtonWrapper onClick={skipToMainContent} data-it="skipToMainContent">
        <LinkButtonContentWrapper>
          <LinkButtonTextWrapper className={css(styles.showOnFocus)}>Skip to main content</LinkButtonTextWrapper>
        </LinkButtonContentWrapper>
      </LinkButtonWrapper>
    </div>
  );
};
